module.exports = __webpack_public_path__ + "img/one-place-cutout.bf3c9e59.webp";